import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ConnectAppsModel } from '../connect-apps.component';

@Component({
  selector: 'launcher-connect-apps',
  templateUrl: './launcher-connect-apps.component.html',
  styleUrls: ['./launcher-connect-apps.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LauncherConnectAppsComponent {
  @Input() model: ConnectAppsModel;
  @Input() canReconnectApp: boolean;
  @Output() connect = new EventEmitter<string>();

  onButtonClick() {
    this.connect.emit(
      this.model.viewName === 'people' && this.canReconnectApp && !this.model.appLinks.length
        ? '/admin/workspace'
        : `/${this.model.viewName}`
    );
  }
}
